import { Nullable } from '../types'
import { isDefined } from './guards'

declare const process: Record<string, unknown>

export function logIfNotTest(logName: string, ...data: unknown[]) {
  if (
    typeof process === 'undefined' ||
    !(typeof process.env === 'object' && isDefined(process.env) && 'JEST_WORKER_ID' in process.env)
  ) {
    console.log(logName, ...data)
  }
}

export function isDevToolsDisabled(): boolean {
  return 'reactDevToolsEnabled' in window && !window.reactDevToolsEnabled
}

const LOCALHOST_ALIASES = ['localhost', '127.0.0.1', '::1']
export function isLocalhost(): boolean {
  return LOCALHOST_ALIASES.includes(window.location.hostname)
}

export function getReduxDevToolsOptions(name: string) {
  if (isDevToolsDisabled()) {
    return false
  }

  const localPrefix = isLocalhost() ? 'local' : 'stand'
  return { name: `${localPrefix}|${document.title}|${name}` }
}

export function ObjectEntries<T extends Record<PropertyKey, unknown>>(
  obj: T,
): { [K in keyof T]: [K, T[K]] }[keyof T][] {
  return Object.entries(obj) as { [K in keyof T]: [K, T[K]] }[keyof T][]
}

export function ObjectKeys<T extends object>(obj: T) {
  return Object.keys(obj) as Array<keyof T>
}

export function preventDefault<Event extends { preventDefault: VoidFunction }>(e: Event) {
  e.preventDefault()
}

export function stopPropagation<Event extends { stopPropagation: VoidFunction }>(e: Event) {
  e.stopPropagation()
}

export function getFontSize(): number {
  const styles = getComputedStyle(document.documentElement)
  const fontSize = styles.getPropertyValue('--main-font-size')
  // biome-ignore lint/performance/useTopLevelRegex: Выполняется не часто
  return Number(/\d+/.exec(fontSize)?.[0] ?? 10)
}

export function convertToArray<T>(data: T | T[]): T[] {
  return Array.isArray(data) ? data : [data]
}

export const arrayFromAsync = async <T>(data: AsyncIterable<T>) => {
  const result: T[] = []
  for await (const iterator of data) {
    result.push(iterator)
  }
  return result
}

export const zip = <T>(...arrays: T[][]) =>
  Array.from({ length: Math.max(...arrays.map(array => array.length)) }, (_, i) =>
    arrays.map(array => array[i]),
  )

export function getFulfilledData<T>(promises: Promise<T>[]) {
  return Promise.allSettled(promises).then(d =>
    d.reduce<T[]>((arr, res) => {
      if (res.status === 'fulfilled') {
        arr.push(res.value)
      }
      return arr
    }, []),
  )
}

export function tuple<T extends unknown[]>(...args: T) {
  return args
}

export function check<T>(arg: T) {
  if (arg == null) throw new Error('Для данного поля значение null/undefined недопустимо')
  return arg
}

export function nullOrValue<T>(value: Nullable<T> | undefined): Nullable<T> {
  if (!isDefined(value)) return null

  return value
}
